module.exports = __webpack_public_path__ + "static/media/covid19Travel.a4b0d974.png";